import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { relationships } from '@/mocks/drama';

const accentMap: Record<string, { badge: string; line: string }> = {
  primary: { badge: 'bg-primary-100 text-primary-700', line: 'bg-primary-500' },
  accent: { badge: 'bg-accent-100 text-accent-900', line: 'bg-accent-500' },
  secondary: { badge: 'bg-secondary-100 text-secondary-800', line: 'bg-secondary-500' },
};

export default function Relationships() {
  return (
    <section id="relationships" className="scroll-mt-32 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="人物关系"
            title="一张被欲望拉扯的关系网"
            desc="这些人物并非孤立的个体：控制、拉拢、对立与情感交织在一起，构成了推动剧情不断升级的关系网。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {relationships.map((rel, index) => {
            const accent = accentMap[rel.accent];
            return (
              <Reveal key={`${rel.from}-${rel.to}`} delay={index * 60}>
                <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-foreground-950 font-heading text-sm font-bold text-background-50">
                      {rel.from.slice(0, 1)}
                    </span>
                    <span className="flex flex-1 items-center gap-2">
                      <span className={`h-[2px] flex-1 rounded-full ${accent.line}`} />
                      <i className="ri-arrow-left-right-line text-foreground-400" />
                      <span className={`h-[2px] flex-1 rounded-full ${accent.line}`} />
                    </span>
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-foreground-800 font-heading text-sm font-bold text-background-50">
                      {rel.to.slice(0, 1)}
                    </span>
                  </div>

                  <div className="mt-4 flex flex-wrap items-center gap-2">
                    <span className="font-heading text-base font-semibold text-foreground-950">
                      {rel.from} · {rel.to}
                    </span>
                    <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${accent.badge}`}>
                      {rel.type}
                    </span>
                  </div>

                  <p className="mt-3 text-sm leading-relaxed text-foreground-700">{rel.desc}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}